import axios from 'axios';
import {downloadFile} from "../../utils/file/download";
import {withoutComma} from "../../utils/calculate/Amount";

export class VentanillaService {
    getBestOrders() {
        return axios.get('/appapv/bestOrder.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload[0]);
    }

    getLenderOrders(emisora) {
        return axios.get('/appapv/lenderOrder.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                emisora: emisora
            }
        }).then(res => res.data.payload[0]);
    }

    getBorrowerOrders(emisora) {
        return axios.get('/appapv/borrowerOrder.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                emisora: emisora
            }
        }).then(res => res.data.payload[0]);
    }

    getLoans(emisora) {
        return axios.get('/appapv/loans.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                emisora: emisora
            }
        }).then(res => res.data.payload[0]);
    }

    getOrderPtm(folio) {
        return axios.get('/appapv/getOrderPtmVentanilla.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                folio: folio
            }
        }).then(res => res.data);
    }

    getOrderPtt(folio) {
        return axios.get('/appapv/getOrderPttVentanilla.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                folio: folio
            }
        }).then(res => res.data);
    }

    takeOrderLenderVentanilla(folio, orderPtm, originalMaturity, originalRate) {
        return axios.post('/appapv/takeOrderLenderVentanilla.action', {},
            {
                params: {
                    folio: folio,
                    cantidadPostura: withoutComma(orderPtm.cantidadDisponible),
                    cantidadSolicitada: withoutComma(orderPtm.cantidad),
                    tasa: orderPtm.tasa,
                    sobreTasa: orderPtm.sobreTasa,
                    plazo: orderPtm.plazo,
                    plazoOriginal: originalMaturity,
                    tasaOriginal: originalRate,
                    premioMin: orderPtm.premioMin,
                    fecValor: orderPtm.fecValor
                }
            }).then(res => res.data);
    }

    takeOrderBorrowerVentanilla(folio, orderPtt) {
        return axios.post('/appapv/takeOrderBorrowerVentanilla.action', {},
            {
                params: {
                    folio: folio,
                    cantidadPostura: withoutComma(orderPtt.cantidadDisponible),
                    cantidadSolicitada: withoutComma(orderPtt.cantidad),
                    cuenta: orderPtt.cuenta,
                    tasa: orderPtt.tasa,
                    sobreTasa: orderPtt.sobreTasa,
                    plazo: orderPtt.plazo,
                    plazoOriginal: orderPtt.plazo,
                    tasaOriginal: orderPtt.tasa,
                    premioMin: orderPtt.premioMin,
                    fecValor: orderPtt.fecValor
                }
            }).then(res => res.data);
    }

    getAverageTrade() {
        return axios.get('/appapv/getAverageTrade.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload[0]);
    }

    exportAverageTrade(format) {
        let url = format === 'XLS'
            ? '/appapv/getAverageTradeXls.action'
            : '/appapv/getAverageTradePdf.action';

        return downloadFile(url);
    }
}